module.exports = __webpack_public_path__ + "static/media/plan_virtual.f5fd7d92.png";